import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import Grid from '@material-ui/core/Grid';
import { API_URL } from '../common/Constants';
import axios from 'axios';
import './introduction.css';

// import TitleText from '../common/TitleText';
// import Pagination from './Pagination';

const styles = (theme) => ({
  orangeColor: {
    color: '#f5821f',
  },

  exImg: {
    width: '100%',
    height: '152px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '254px',
    },
  },

  examplesWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  examplesMob: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});
// const examples = [
//   { img: './images/souvenir/ex1@2x.png', text: '동해시 자석책갈피' },
//   { img: './images/souvenir/ex2@2x.png', text: '봉평 자석책갈피' },
//   { img: './images/souvenir/ex3@2x.png', text: '동해시 삼각대자석' },
//   { img: './images/souvenir/ex4@2x.png', text: '김포시 문수산성 삼각대자석' },
//   { img: './images/souvenir/ex5@2x.png', text: '국립생태원 삼각대자석' },
//   { img: './images/souvenir/ex6@2x.png', text: '봉평 삼각대자석' },
//   { img: './images/souvenir/ex7@2x.png', text: '고성군 삼각대자석' },
//   { img: './images/souvenir/ex8@2x.png', text: '서산 자석책갈피' },
//   { img: './images/souvenir/ex9@2x.png', text: '당진시 합덕성당 삼각대자석' },
//   { img: './images/souvenir/ex10@2x.png', text: '파주시 DMZ 삼각대자석' },
//   { img: './images/souvenir/ex11@2x.png', text: '예산군 다기능 자석책갈피' },
//   { img: './images/souvenir/ex12@2x.png', text: '강릉단오제 삼각대자석' },
// ];
class Souvenir extends Component {
  constructor(props) {
    super(props);

    this.state = { currentPage: 0, perPage: 4, imgData: '' };
    // this.changePage = this.changePage.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${API_URL}/admin/menuInfo`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data);
        let _result = response.data;
        this.setState({ imgData: _result });
        // console.log('imgData', this.state.imgData);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentWillUnmount() {}
  // changePage(e, direction) {
  //   if (direction === 'prev') {
  //     if (this.state.currentPage > 0) {
  //       this.setState({ currentPage: this.state.currentPage - 1 });
  //     }
  //   } else {
  //     if (this.state.currentPage < parseInt(examples.length / this.state.perPage) - 1) {
  //       this.setState({ currentPage: this.state.currentPage + 1 });
  //     }
  //   }
  // }
  render() {
    // const { classes } = this.props;
    // const { currentPage, perPage } = this.state;
    // const indexFirst = perPage * currentPage;
    // const indexLast = indexFirst + perPage;
    // const showExamples = examples.slice(indexFirst, indexLast);
    return (
      <React.Fragment>
        <Topbar />
        <div className="dw_bg">
          <Grid
            id="index_grid"
            container
            justify="flex-start"
            style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}
          >
            <b>제품소개 〉 기념품</b>
          </Grid>
          <div className="bg_inner">
            <img
              src={this.state.imgData.m2_5}
              onContextMenu={(e) => e.preventDefault()} //스탬프 이미지 우클릭 다운로드 방지
              alt={'img'}
              style={{ width: '100%', paddingTop: '4vh', WebkitTouchCallout: 'none' }}
            />
            {/* <TitleText title="기념품" />
            <p align="center" className="mainTxt">
              대상에 맞는&nbsp;
              <br className={classes.examplesMob} />
              특화된 기념품 제작
            </p>
            <Grid container justify="center" alignItems="center">
              <img src="./images/souvenir/circles@2x.png" alt="" className="circles" style={{WebkitTouchCallout: 'none'}} />
            </Grid>

            <p align="center" className="descTxt">
              본사의 <span style={{ color: '#ba69a4' }}>특화된 사업의 일환</span>으로 <br className={classes.examplesMob} />
              기념품 제작을 들 수 있습니다.
              <br /> 스탬프투어 완주나 축제, 행사 등에서 제공되는 기념품이나
              <br /> 참가, 방문기념 및 VIP 대상 기념품을 <span style={{ color: '#ba69a4' }}>창의적으로 제작</span>합니다.
            </p>
            <Grid container justify="center" alignItems="center" style={{ backgroundColor: '#e9eff8' }}>
              <img src="./images/souvenir/books@2x.png" alt="" className="mainImg" style={{ padding: '20px 0', WebkitTouchCallout: 'none' }} />
            </Grid>
            <Grid container direction="column" justify="center" className="grayBox">
              <div className="infoTxt">
                <img src="./images/stampbook/ic_info.png" alt="infomation" style={{WebkitTouchCallout: 'none'}} />
                <p>
                  기존 시판용 판촉물에 <b>로고만 찍는 형식은 배제</b>
                </p>
              </div>

              <ul className="features">
                <li>
                  <b>대상에 맞는 특화된 기념품</b>을 제작
                </li>
                <li>
                  <b>실용성과 경제성</b>을 더하여 그 가치를 높힘
                </li>
                <li>
                  기념품 제작에 있어 <b>날인이미지를 활용할 경우 디자인 비용을 절약</b>
                </li>
                <li>
                  아이디어 및 디자인 도용문제로 기념품 일부만 예를 들어 소개드립니다.
                  <br />
                  기타 제품에 관하여 궁금하신점이나 필요하신 내용은 직접 자세한 상담 받아보시기 바랍니다.
                </li>
              </ul>
            </Grid>
            <p style={{ backgroundColor: '#f5f5f5', height: '1px', width: '100%', marginBottom: '40px' }} />
            <Grid>
              <Pagination
                pageText="납품 사례"
                examples={examples}
                currentPage={this.state.currentPage}
                perPage={this.state.perPage}
                changePage={this.changePage}
              />
            </Grid>
            <Grid container className={classes.examplesMob} spacing={2} style={{ paddingTop: '40px' }}>
              {showExamples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" xs={6}>
                  <p
                    style={{
                      width: '100%',
                      margin: 0,
                      height: '25vw',
                      overflow: 'hidden',
                      border: '1px solid #efefef',
                    }}
                  >
                    <img src={example.img} alt="infomation" style={{ width: '100%', display: 'block', WebkitTouchCallout: 'none' }} />
                  </p>
                  <p style={{ fontSize: '1.1em', marginBottom: 0, wordBreak: 'keep-all', textAlign: 'center' }}>{example.text}</p>
                </Grid>
              ))}
            </Grid>
            <Grid container className={classes.examplesWeb} style={{ paddingTop: '20px' }} spacing={3}>
              {examples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" sm={3}>
                  <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className={classes.exImg}
                    style={{ margin: 0, border: '1px solid #efefef' }}
                  >
                    <img src={example.img} alt="infomation" style={{ width: '95%', display: 'block', WebkitTouchCallout: 'none' }} />
                  </Grid>
                  <p className="exTxt">{example.text}</p>
                </Grid>
              ))}
            </Grid> */}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(Souvenir));
